import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { BrowserRouter } from "react-router-dom"
import reducers from './reducers'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './theme'

const store = createStore(reducers, {
  locale: 'es-ES'
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
